import { render, staticRenderFns } from "./SelectSearch.vue?vue&type=template&id=4b36168a"
import script from "./SelectSearch.vue?vue&type=script&lang=js"
export * from "./SelectSearch.vue?vue&type=script&lang=js"
import style0 from "./SelectSearch.vue?vue&type=style&index=0&id=4b36168a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports